import React from 'react';
import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import Quantity from "./Cells/Quantity";
import AmountTd, {AmountTdWidth} from "../../../Table/Common/AmountTd";
import { LockIcon } from '../../../Access/common/LockIcon';
import ProfitPct from './Cells/ProfitPct';

function getColumns(props) {
    const { reportData, hideInventoryCosting } = props;

    const companyCurrencySymbol = reportData?.company?.currency_symbol;

    const renderAmount = amount => {
        if (hideInventoryCosting)
            return (<LockIcon className="grey" />);

        if (amount === '' || amount === undefined || amount === null)
            return null;

        return (
            <AmountTd
                amount={amount}
                currency_symbol={companyCurrencySymbol}
            />
        );
    };

    const renderText = (text, isIndented = false) => (
        <div className={`BaseTable__row-cell-text ${isIndented ? 'indent-col' : ''}`}>
            {text || '-'}
        </div>
    );

    return [
        {
            title: t`Product`,
            key: 'product',
            align: 'left',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => renderText(rowData.product, true),
        },
        {
            title: t`SKU`,
            key: 'sku',
            align: 'left',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData }) => renderText(rowData.sku),
        },
        {
            title: t`Quantity`,
            key: 'quantity',
            align: 'right',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => <Quantity record={record} />,
        },
        {
            title: t`UOM`,
            key: 'uom',
            align: 'left',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData }) => renderText(rowData.uom),
        },
        {
            title: t`Average Price`,
            key: 'base_average_price',
            align: 'right',
            cellRenderer: ({ rowData }) => renderAmount(rowData.base_average_price),
            width: AmountTdWidth,
        },
        {
            title: t`Amount`,
            key: 'base_amount',
            align: 'right',
            cellRenderer: ({ rowData }) => renderAmount(rowData.base_amount),
            width: AmountTdWidth,
        },
        {
            title: t`Cost`,
            key: 'base_cost',
            align: 'right',
            cellRenderer: ({ rowData }) => renderAmount(rowData.base_cost),
            width: AmountTdWidth,
        },
        {
            title: t`Profit`,
            key: 'base_profit',
            align: 'right',
            cellRenderer: ({ rowData }) => renderAmount(rowData.base_profit),
            width: AmountTdWidth,
        },
        {
            title: t`Profit %`,
            key: 'base_profit_pct',
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData: record }) => <ProfitPct
                record={record}
                hideInventoryCosting={hideInventoryCosting}
            />,
        },
    ];
}

export default {
    storageKey: StorageKey.report_profit_detail,
    getReportLabel: () => t`Profit Detail`,
    required: [
        'product',
        'base_amount',
        'base_cost',
        'base_profit',
    ],
    defaulto: [
        'product',
        'sku',
        'quantity',
        'base_amount',
        'base_cost',
        'base_profit',
        'base_profit_pct',
    ],
    getColumns,
};
